import { nodes } from '../convert-prosemirror-to-markdown/pm-markdown/serializer';

/**
 * Extracts the support levels for each node type from the given NodeSerializerSpec.
 *
 * @example
 * ```ts
 * const supportLevels = getNodeSupport();
 * console.log(supportLevels);
 * // Output:
 * // {
 * //   blockquote: 'full',
 * //   codeBlock: 'full',
 * // }
 * ```
 */
export const getNodeSupport = () => {
	const nodeSupport: Record<string, string> = Object.fromEntries(
		Object.entries(nodes).map(([key, value]) => [key, value.support]),
	);

	return nodeSupport;
};
